module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_tiktok-544b76da7b635568f73ebbf9ff086c3f.png";